import GroupForm from '@/components/groups/GroupForm';

export default function CreateGroupPage() {
  return <GroupForm />;
}
